module.exports = __webpack_public_path__ + "static/img-8-d8aaa66c88e39421d0e0fe66f09000e7.jpeg";